module.exports = __webpack_public_path__ + "img/notification-validated.ed46b9d7.svg";